<template>
  <div>
    <div
      class="pa-3"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <v-btn
        :to="`/weserve_admin_login/-/maindinein/storemanage`"
        icon
        color="#e9e9e9"
        ><v-icon>arrow_back</v-icon></v-btn
      >
      <h1>Product List in {{ $route.params.store_name }}</h1>
      <v-btn fab color="primary" @click="formProductDialog = true"
        ><v-icon color="black">add</v-icon></v-btn
      >
    </div>
    <v-card class="elevation-0" style="border: 1px solid black">
      <v-data-table
        :headers="headers"
        :loading="isLoadingData"
        :items="productList"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td style="display: flex; justify-content: center; margin-top: 25px">
            <div>
              <v-switch
                v-model="props.item.product_status"
                color="primary"
                @change="changeState(props.item)"
              ></v-switch>
            </div>
          </td>

          <td class="text-xs-center">
            {{ props.item.product_name_th }}
            <div style="color: grey">({{ props.item.product_name_en }})</div>
          </td>
          <td class="text-xs-center">
            {{ props.item.product_base_price }}
          </td>

          <td class="text-xs-center">
            {{ props.item.product_course_amount }}
          </td>
          <td class="text-xs-center">
            <div
              v-if="
                props.item.product_minimum_person !=
                props.item.product_maximum_person
              "
            >
              {{ props.item.product_minimum_person }} -
              {{ props.item.product_maximum_person }}
            </div>
            <div v-else>{{ props.item.product_maximum_person }}</div>
          </td>

          <td
            class="text-xs-center"
            v-if="props.item.product_booking_expiration"
          >
            {{
              moment(props.item.product_booking_expiration).format(
                "MMMM Do YYYY, HH:mm:ss"
              )
            }}
          </td>
          <td class="text-xs-center" v-else>-</td>
          <td class="text-xs-center">
            <v-btn
              icon
              class="view-detail-btn"
              color="primary"
              @click="toEditProduct(props.item, props.index)"
            >
              <v-icon style="font-size: 18px; color: black">edit</v-icon>
            </v-btn>

            <v-btn
              icon
              class="view-detail-btn"
              color="error"
              @click="deleteItem(props.item)"
              :loading="isDeleteProduct.includes(props.item.product_id)"
            >
              <v-icon style="font-size: 18px; color: white">delete</v-icon>
            </v-btn>
          </td>
        </template>

        <template slot="no-data">
          <div
            v-if="productList.length == 0 && isLoadingData != true"
            class="text-xs-center"
          >
            No data available
          </div>
          <div v-else class="text-xs-center">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            {{ isLoadingData == true ? "Loading data ..." : isLoadingData }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <FormProductDinein
      :dialog="formProductDialog"
      :editedIndex="selected_index"
      @onClose="
        formProductDialog = false;
        selected_index = -1;
      "
      @onSaved="
        formProductDialog = false;
        selected_index = -1;
      "
      :selected_item="selected_item"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import FormProductDinein from "@/components/back-office/DineIn/Product/FormProductDinein.vue";
export default {
  data: () => ({
    search: "",
    detail_dialog: false,
    selected_item: {},
    selected_index: -1,
    dialog: false,
    change: 0,
    isLoadingData: false,
    edit_store_id: 0,
    edit_store_name: "",
    edit_time_name: "",
    edit_time_id: 0,
    testData: "",
    disable_popular: false,
    store_name_th: null,
    delete_id: "",
    pagination: {
      page_size: 100,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Product name",
        align: "center",
        value: "store_province",
        sortable: false,
      },
      {
        text: "Price (THB)",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Course",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "Person",
        align: "center",
        value: "store_tel",
        sortable: false,
      },
      {
        text: "Booking Expired",
        align: "center",
        value: "store_tel",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
    formProductDialog: false,
    isDeleteProduct: [],
  }),
  components: { FormProductDinein },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      productList: (state) => state.fetchDineIn.productListByStore,
    }),
    ...mapGetters(["isEditStoreApprove"]),
    pages() {
      if (this.dinein_store_list.length != 0) {
        this.pagination.totalItems = this.dinein_store_list.length;
      }
      if (
        this.pagination.page_size == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(this.pagination.totalItems / this.pagination.page_size);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      fetchProductList: "fetchDineIn/fetchProductList",
      changeStatusProductByID: "fetchDineIn/updateStatusProductByID",
    }),
    moment,
    toEditProduct(item, index) {
      this.selected_item = item;
      this.selected_index = index;
      this.formProductDialog = true;
    },
    async deleteStore() {
      var res = await this.$store.dispatch(
        "fetchDineIn/deleteDineInStore",
        this.delete_id
      );
      if (res == true) {
      }
    },
    async changeState(item) {
      let res = await this.changeStatusProductByID({
        status: item.product_status,
        productID: item.product_id,
      });
      if (res === false) {
        item.product_status != item.product_status;
      }
    },
    async fetchData() {
      this.isLoadingData = true;
      this.$store.commit("fetchDineIn/setProductListByStore", []);
      await this.$store.dispatch("fetchDineIn/fetchProductList", {
        storeID: this.$route.params.store_id,
      });
      this.isLoadingData = false;
    },
    async deleteItem(item) {
      let n = await this.$confirm("Do you want to delete this package ?");
      if (n == true) {
        this.isDeleteProduct.push(item.product_id);
        let result = await this.$store.dispatch(
          "fetchDineIn/removeDineInProduct",
          {
            productID: item.product_id,
          }
        );
        let index = this.isDeleteProduct.findIndex(
          (val) => item.product_id == val
        );
        this.isDeleteProduct.splice(index, 1);
        if (result == true) {
          alert("Delete package successfully");
        } else {
          alert("Can't delete package");
        }
      }
    },
  },
};
</script>

<style scoped>
.view-detail-btn {
  font-size: 13px;
  outline: none;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
